import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import clsx from 'clsx';
import actions from './actions';
import { roles } from '../cassandra-shared-js/roles';
import { hasPermission } from './index';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  sticky: {
    position: 'sticky',
    width: 350,
    left: 0,
    background: 'white',
    boxShadow: '5px 2px 5px grey',
  },
  booleanCell: {
    padding: 10,
  },
  dot: {
    width: 20,
    height: 20,
    borderRadius: '100%',
    margin: 'auto',
  },
  greenDot: {
    backgroundColor: 'green',
  },
  redDot: {
    backgroundColor: 'rgba(255,0,0, 0.3)',
  },
});

const RolesActionsTable = () => {
  const classes = useStyles();

  const rolesArray = Object.keys(roles);
  const actionsArray = Object.keys(actions);

  return (
    <>
      <TableContainer style={ { border: '1px solid black' } }>
        <Table
          className={ classes.table }
          aria-label='simple table'
          style={ { tableLayout: 'fixed' } }
        >
          <TableHead>
            <TableRow>
              <TableCell className={ classes.sticky }>
                Roles / Actions
              </TableCell>
              {
                actionsArray.map((action) => {
                  return (
                    <TableCell key={ action } align='center' style={ { width: 250 } }>
                      {action}
                    </TableCell>
                  );
                })
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {
              rolesArray.map((role) => {
                return (
                  <TableRow key={ role }>
                    <TableCell
                      className={ classes.sticky }
                      component='th'
                      scope='row'
                    >
                      {role}
                    </TableCell>
                    {
                      actionsArray.map((action) => {
                        return (
                          <TableCell
                            key={ `${ role }-${ action }` }
                            align='center'
                            className={ classes.booleanCell }
                          >
                            <div className={ clsx(classes.dot, hasPermission(role)(action) ? classes.greenDot : classes.redDot) } />
                          </TableCell>
                        );
                      })
                    }
                  </TableRow>
                );
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

const RolesActionsPermissions = () => {
  return <RolesActionsTable />;
};

export default RolesActionsPermissions;
